import { Controller } from "../vendor/stimulus.js";

const ACCEPT_IMAGE_URL = "/upload/initial/approve";
const DENY_IMAGE_URL = "/upload/initial/deny";

export default class extends Controller {

  static targets = [
    "base64Input" // hidden input
  ]

  connect() {
    this.handleBase64Change = this.uploadImage.bind(this);
    this.handleFormSubmit = (event) => event.preventDefault();
    if (this.hasBase64InputTarget) {
      this.base64InputTarget.addEventListener("change", this.handleBase64Change);
    }
    this.element?.addEventListener("submit", this.handleFormSubmit);
  }

  disconnect() {
    if (this.hasBase64InputTarget && this.handleBase64Change) {
      this.base64InputTarget.removeEventListener("change", this.handleBase64Change);
    }
    if (this.element && this.handleFormSubmit) {
      this.element.removeEventListener("submit", this.handleFormSubmit);
    }
  }

  uploadImage(event) {
    event?.preventDefault?.();
    const base64Value = this.hasBase64InputTarget ? this.base64InputTarget.value.trim() : "";
    if (!base64Value) return;

    this.dispatchEvent("moodboard:upload-started");

    const action = this.element.getAttribute("action") || this.element.action || window.location.href;
    const request = new XMLHttpRequest();
    request.open("POST", action, true);
    request.withCredentials = true;
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        this.dispatchEvent("moodboard:uploaded", { response: request.responseText });
      } else {
        this.dispatchEvent("moodboard:error", { status: request.status });
        this.emitGlobalXhrFailed(request.status);
      }
    };
    request.onerror = () => {
      this.dispatchEvent("moodboard:error");
      this.emitGlobalXhrFailed();
    };
    request.send(new FormData(this.element));
  }

  acceptImage() {
    const request = new XMLHttpRequest();
    request.open("POST", ACCEPT_IMAGE_URL, true);
    request.withCredentials = true;
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        this.dispatchEvent("moodboard:accepted");
      } else {
        this.emitGlobalXhrFailed(request.status);
      }
    };
    request.send();
  }

  denyImage() {
    const request = new XMLHttpRequest();
    request.open("POST", DENY_IMAGE_URL, true);
    request.withCredentials = true;
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        // successful
      } else {
        this.emitGlobalXhrFailed(request.status);
      }
    };
    this.dispatchEvent("moodboard:denied");
    this.dispatchEvent("moodboard:clear-upload");
    request.send();
  }

  dispatchEvent(name, detail = {}, target = this.element) {
    if (!target) return;
    const event = new CustomEvent(name, {
      detail,
      bubbles: true
    });
    target.dispatchEvent(event);
  }

  emitGlobalXhrFailed(status = null) {
    const detail = { status };
    window.dispatchEvent(new CustomEvent("xhr-failed", { detail }));
  }
}
